import { Card, CardContent, Grid, Icon, LinearProgress, Typography } from "@mui/material";
import { GridContainer, GridFlexBox } from "../themes/themes";
import isFileImage from "../utils-functions/isFileImage";
import { useEffect, useState } from "react";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { uploadFile } from "../functions/uploadFile";

export default function FileCard({ i, file, handleDelete, startUpload, returnFile, folderId }) {
    const [progress, setProgress] = useState(0);
    const { user } = useContext(AuthContext);

    useEffect(() => {
        if (startUpload) {
            upload();
        }
    }, [startUpload]);

    const upload = async () => {
        if (!file) {
            return;
        }

        const folderRef = `files/${user.email}/${folderId}`;
        const fileRef = folderRef + "/" + file.name;
        const downloadURL = await uploadFile(file, fileRef, setProgress);
        console.log(downloadURL);

        const reference = {
            name: file.name,
            folderRef: folderRef,
            type: file.type,
            downloadURL: downloadURL
        };

        returnFile(reference, i, downloadURL);
    };

    return (
        <Card style={{ width: "100%", marginTop: "3px", padding: 3 }} key={i}>
            <CardContent style={{ padding: 3 }}>
                <GridContainer>
                    <GridFlexBox w="10%" fs>
                        {isFileImage(file) ? (
                            <img width={"100%"} src={URL.createObjectURL(file)} alt="" />
                        ) : (
                            <Icon fontSize="large" color="primary">
                                article
                            </Icon>
                        )}
                    </GridFlexBox>
                    <GridFlexBox w="80%" fs>
                        <Typography variant="body2" style={{ marginLeft: "5px" }}>
                            <a href={file.downloadURL} target="blank">
                                {file.name}
                            </a>
                        </Typography>
                    </GridFlexBox>
                    <GridFlexBox w="10%" fe>
                        <Icon
                            fontSize="small"
                            style={{
                                color: "darkred",
                                cursor: "pointer",
                                display: startUpload ? "none" : "block"
                            }}
                            onClick={() => handleDelete(i)}
                        >
                            delete
                        </Icon>
                    </GridFlexBox>
                    <Grid item xs={12}>
                        <LinearProgress variant="determinate" value={progress} />
                    </Grid>
                </GridContainer>
            </CardContent>
        </Card>
    );
}
